module.exports = __webpack_public_path__ + "img/bb_st_hubert_creme.b80555d4.jpg";